// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"377":"4e7c205f","453":"0e54b539"}[chunkId] + ".css";
};